import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["includeCheckbox", "variationSection"]

  connect() {
    this.updateInclusion()
  }

  includeToggled() {
    this.updateInclusion()
  }

  updateInclusion() {
    const included = !this.hasIncludeCheckboxTarget || this.includeCheckboxTarget.checked
    this.element.classList.toggle("opacity-50", !included)
    this.variationSectionTargets.forEach(section => {
      section.querySelectorAll("input, select").forEach(input => { input.disabled = !included })
    })
  }
}
